<section class="landing-inversores__process landing-inversores__container">
  <div class="landing-inversores__process-intro">
    <p class="landing-inversores__eyebrow">Cómo funciona</p>
    <h2 class="landing-inversores__section-title">Elimina la fricción del proceso</h2>
    <p class="landing-inversores__section-subtitle">Sencillo y rápido: filtra, compara, oferta y firma online.</p>
  </div>

  <div class="landing-inversores__process-grid">
    <div class="landing-inversores__card landing-inversores__shadow-soft landing-inversores__process-step" *ngFor="let s of steps">
      <div class="landing-inversores__process-step-number">{{ s.n }}</div>
      <h3 class="landing-inversores__process-step-title">{{ s.title }}</h3>
      <p class="landing-inversores__process-step-desc">{{ s.desc }}</p>
    </div>
  </div>
</section>
